import { inject } from 'mobx-react';
import * as React from 'react';

import { CurrentHotelStore } from 'stores/current-hotel-store';

import { UitkSpacing } from 'uitk-react-spacing';

import { SharedUiSpaceDetailsExperiment } from 'components/infosite/shared-ui/experiments/space-details-experiment';

interface SpaceDetailsWrapperProps {
  currentHotel?: CurrentHotelStore;
}

export const SpaceDetailsWrapper: React.FunctionComponent<SpaceDetailsWrapperProps> = inject('currentHotel')(props => (
  <UitkSpacing margin={{ block: 'six' }}>
    <div>
      {props.currentHotel?.offers?.spacesViewModel && (
        <SharedUiSpaceDetailsExperiment spacesViewModel={props.currentHotel.offers.spacesViewModel} />
      )}
    </div>
  </UitkSpacing>
));
